<h2>Form Layout</h2>
<p class="demo-description">Demonstrates <code>upp-form</code> sections, actions, warnings, and button bars.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleSectionFill()">Section fill: {{ sectionFill }}</ion-button>
    <ion-button size="small" (click)="toggleButtonsFloat()">Buttons float: {{ buttonsFloat }}</ion-button>
    <ion-button size="small" (click)="toggleWarningLines()">Warning lines: {{ warningLines }}</ion-button>
    <ion-button size="small" (click)="toggleWarning()">{{ showWarning ? 'Hide' : 'Show' }} Warning</ion-button>
</div>

<!-- upp-form demo -->
<div class="demo-section">
    <h3>upp-form with sections</h3>
    <div style="border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-form [formGroup]="form">

            <upp-form-section
                title="Personal Information"
                subtitle="Fill in your details"
                icon="person-outline"
                [fill]="sectionFill">
                <div style="padding: 8px 16px;">
                    <upp-input
                        formControlName="name"
                        placeholder="Full name"
                        title="Name"
                        [kiosk]="false">
                    </upp-input>
                    <upp-input
                        formControlName="email"
                        placeholder="email@example.com"
                        title="Email"
                        [kiosk]="false">
                    </upp-input>
                </div>
            </upp-form-section>

            <upp-form-section
                title="Additional Notes"
                subtitle="Optional"
                icon="document-text-outline"
                [fill]="sectionFill">
                <div style="padding: 8px 16px;">
                    <upp-textarea
                        formControlName="notes"
                        placeholder="Write any notes..."
                        title="Notes"
                        [rows]="3"
                        [kiosk]="false">
                    </upp-textarea>
                </div>
            </upp-form-section>

            <!-- Warning -->
            <upp-form-warning *ngIf="showWarning"
                color="warning"
                [lines]="warningLines"
                icon="alert-circle-outline"
                title="Attention"
                subtitle="Please review all fields before submitting.">
            </upp-form-warning>

            <!-- Action -->
            <upp-form-action
                color="primary"
                icon="save-outline"
                title="Save Draft"
                subtitle="Saves without submitting">
            </upp-form-action>

            <!-- Button bar -->
            <upp-form-buttonbar>
                <upp-form-barbutton [active]="true">
                    <ion-button color="primary" expand="block">
                        <ion-icon name="checkmark-outline" slot="start"></ion-icon>
                        Submit
                    </ion-button>
                </upp-form-barbutton>
                <upp-form-barbutton [active]="true">
                    <ion-button color="medium" expand="block" fill="outline">
                        <ion-icon name="close-outline" slot="start"></ion-icon>
                        Cancel
                    </ion-button>
                </upp-form-barbutton>
            </upp-form-buttonbar>

            <!-- Buttons -->
            <upp-form-buttons [float]="buttonsFloat">
                <ion-button size="small" color="success">
                    <ion-icon name="add-outline" slot="start"></ion-icon>
                    Add Section
                </ion-button>
                <ion-button size="small" color="danger" fill="outline">
                    <ion-icon name="trash-outline" slot="start"></ion-icon>
                    Remove
                </ion-button>
            </upp-form-buttons>

        </upp-form>
    </div>
</div>
